// CUSTOM: personalised-v2-sticky-cta.js
// Sticky "Back to Pack" CTA bar controller for the v2 library page.
//
// Visible only for quiz users with at least one item in their active pack.
// Bootstrapped via the plv2:ready event (fired by personalised-library-v2.js)
// so it always receives coherent initial state.
//
// Listens to plv2:item-added and plv2:item-removed to update count and price
// dynamically while the user browses.
//
// Exposes: window.personalised.stickyCta — { init, update }

(function () {
  'use strict';

  window.personalised = window.personalised || {};

  // ---------------------------------------------------------------------------
  // Module state
  // ---------------------------------------------------------------------------

  var _el = null; // the #plv2-sticky-cta DOM element

  // ---------------------------------------------------------------------------
  // Helpers
  // ---------------------------------------------------------------------------

  /**
   * Compute the total monthly price (in cents) for the given bundle items.
   * Uses window.personalised.libraryV2.productMap as the price source.
   * Skips items whose product is not found in the map (edge case: AC edge case —
   * "Product price data not found in product pool").
   *
   * @param {Array} bundleItems  — items from window.personalised.bundle.getItems()
   * @returns {number}  total price in cents
   */
  function _computeTotal(bundleItems) {
    var productMap = window.personalised.libraryV2 && window.personalised.libraryV2.productMap;
    if (!productMap) { return 0; }
    var total = 0;
    bundleItems.forEach(function (item) {
      var data = productMap.get(String(item.productId));
      if (data) { total += data.price; }
    });
    return total;
  }

  // ---------------------------------------------------------------------------
  // 1. Public API
  // ---------------------------------------------------------------------------

  /**
   * Show/hide based on user state.
   * Aborts silently if the user doesn't qualify (no quiz, or empty pack).
   *
   * @param {{ hasQuiz: boolean, bundleItems: Array }} state
   */
  function init(state) {
    _el = document.getElementById('plv2-sticky-cta');
    if (!_el) {
      console.warn('[StickyCta] #plv2-sticky-cta element not found');
      return;
    }

    // Bind events for all users so the bar appears when items are added
    _bindEvents();

    var bundleItems = (state && state.bundleItems) || [];
    if (bundleItems.length > 0) {
      update(bundleItems);
      _el.hidden = false;
    }
    // If pack is empty the bar stays hidden — _bindEvents() above will show
    // it as soon as the first plv2:item-added fires.
  }

  /**
   * Refresh item count and price total from the latest bundle items array.
   * Safe to call even if the bar is hidden.
   *
   * @param {Array} bundleItems
   */
  function update(bundleItems) {
    if (!_el) { return; }

    var count    = bundleItems.length;
    var countEl  = _el.querySelector('[data-sticky-count]');

    if (countEl) {
      countEl.textContent = count + (count !== 1 ? ' items' : ' item') + ' in your pack';
    }
  }

  // ---------------------------------------------------------------------------
  // 2. Event bindings
  // ---------------------------------------------------------------------------

  /**
   * Attach plv2:item-added / plv2:item-removed listeners.
   * Called once from init — listeners are permanent for the page lifetime.
   */
  function _bindEvents() {
    document.addEventListener('plv2:item-added', function () {
      var bundle = window.personalised && window.personalised.bundle;
      var items  = bundle ? bundle.getItems() : [];
      update(items);
      // Show bar in case it was hidden (user re-added after emptying pack)
      if (_el && _el.hidden) { _el.hidden = false; }
    });

    document.addEventListener('plv2:item-removed', function () {
      var bundle = window.personalised && window.personalised.bundle;
      var items  = bundle ? bundle.getItems() : [];
      update(items);
      // Hide bar when pack is empty
      if (_el && items.length === 0) { _el.hidden = true; }
    });
  }

  // ---------------------------------------------------------------------------
  // 3. Register public API
  // ---------------------------------------------------------------------------

  window.personalised.stickyCta = {
    init:   init,
    update: update
  };

  // ---------------------------------------------------------------------------
  // 4. Bootstrap — wait for plv2:ready so state is coherent
  // ---------------------------------------------------------------------------

  document.addEventListener('plv2:ready', function () {
    var lv2 = window.personalised.libraryV2;
    if (!lv2) {
      console.warn('[StickyCta] plv2:ready fired but window.personalised.libraryV2 not set');
      return;
    }
    init(lv2.state);
  });

})();
